<template>
  <div>
    <van-nav-bar
      class="f-s-6"
      title="确认支付"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-row class="bodyDaya">
      <!-- title信息 -->
      <van-col :span="24" class="bg-white titleMsg">
        <van-tag class="m-r-02 f-s-6" style="width:1.6rem;height:0.9rem;">土建</van-tag>
        <span class="f-s-8">资料资料图学会BIM考试一二级考班班</span>
        <p class="text-r f-s-8 m-t-10">¥4980</p>
      </van-col>
      <!-- 优惠 -->
      <van-col :span="24" class="discount m-t-05 f-s-8">
        优惠
        <van-tag color="#E74C27" text-color=#FFFFFF class="m-l-02 f-s-6" style="width:1.6rem;height:0.9rem;">拼团</van-tag>
        <span class="f-l-r discountMoney">-¥4969</span>
      </van-col>
      <!-- 支付方式 -->
      <van-col :span="24" class="paymentMet m-t-05">
        <p class="f-s-8">支付方式</p>
        <van-row class="f-s-8">
          <van-radio-group v-model="radio">
            <van-col :span="24" @click="pay('1')" class="m-t-07">
              <span>微信</span>
               <van-radio name="1" class="f-l-r"></van-radio>
            </van-col>
            <van-col :span="24" @click="pay('2')" class="m-t-07">
              <span>支付宝</span>
               <van-radio name="2" class="f-l-r"></van-radio>
            </van-col>
          </van-radio-group>
        </van-row>
      </van-col>
      <!-- 商品总额 -->
      <van-col :span="24" class="discount m-t-05 f-s-8">
        商品总额
        <span class="f-l-r">¥4969</span>
      </van-col>
    </van-row>
    <van-row class="payFooter">
      应付:<span style="color:#FC7D16;font-size:1.2rem">¥4498</span>
      <van-button class="xz-button-info f-l-r f-s-6 payBtn">确认支付</van-button>
    </van-row>
  </div>
</template>

<script>
export default {
  props:{},
  data(){
    return {
      radio:"1"
    }
  },
  methods :{
    pay(data){
      this.radio = data
    }
  }
}
</script>

<style lang="less" scoped>
.bodyDaya {
  padding-top: 0.8rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
// 支付按钮
.payBtn {
border-radius: 1.3rem;margin-top:0.8rem;margin-right:1.75rem;width:7.5rem;height:2rem
}
// 支付底部
.payFooter {
  position:fixed;
  bottom: 0px;
  width: 100%;
  background-color: #FFFFFF;
  height: 3.5rem;
  line-height: 3.5rem;
  font-size: 0.8rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
// 顶部信息
.titleMsg {
  padding: 0.95rem 0.75rem 0.75rem 0.75rem;
  border-radius: 0.3rem;
}
// 支付方式
.paymentMet {
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  background-color: white;
  border-radius: 0.3rem;
}
// 优惠信息
.discount{
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  background-color: white;
  border-radius: 0.3rem;
}
.discountMoney {
  color: #FD7E18;
  font-size: 0.8rem;
}
</style>